import * as React from "react";
import * as ReactDOM from "react-dom/client";
import './index.css';

import reportWebVitals from './reportWebVitals';
import { Amplify } from 'aws-amplify';
import awsconfig from './aws-exports';
import {
  BrowserRouter
} from "react-router-dom";
import App from "./App.tsx";
import { AuthProvider } from "react-oidc-context";

Amplify.configure(awsconfig);


const cognitoAuthConfig = {
    authority: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_k0G9vamFJ",
    client_id: "3038j686qjsakmdj8te22jd8ud",
    redirect_uri: "http://localhost:3000/",
    response_type: "code",
    scope: "email openid phone profile",
};
  

ReactDOM.createRoot(document.getElementById("root")!).render(
  
    <BrowserRouter>
      <AuthProvider {...cognitoAuthConfig}>
        <App />
      </AuthProvider>
    </BrowserRouter>
  
    

);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
